/**
 * Throws a new `Error` with the specified message and optional error options.
 *
 * @param message - The error message to be used for the thrown `Error`.
 * @param options - Optional `ErrorOptions` to provide additional error context.
 * @throws {Error} Always throws an error with the provided message and options.
 * @example
 * ```typescript
 * // Using in a ternary operation
 * const result = isValid ? execute() : raise('Invalid operation');
 * ```
 */
export const raise = (message: string, options?: ErrorOptions): never => {
  throw new Error(message, options);
};
